<div class="otp-container">
  <input *ngFor="let input of otpInputs; let i = index" [attr.data-index]="i" [(ngModel)]="otp[i]"
    (input)="onInputChange(i)" (keydown)="onKeyDown($event, i)" (paste)="onPaste($event, i)" type="text" maxlength="1"
    class="otp-input" [class.active]="activeIndex === i" [class.completed]="otp[i] !== ''" />
</div>

<div class="otp-reenvio">

  <a *ngIf="!isDisabled" (click)="onLinkClick()" class=" mb-1 small text-decoration-none mt-3">¿No recibiste un código? <strong>Reenviar </strong> <strong>({{ tiempoRestante
      }})</strong> seg.</a>

  <a *ngIf="isDisabled" class=" mb-1 text-muted small text-decoration-none mt-3">¿No recibiste un código? <strong>Reenviar </strong> <strong>({{ tiempoRestante
      }})</strong> seg.</a>
</div>
